import classNames from 'classnames';
import { useProductPageContext } from '@/components/v2/product/hooks/useProductPageContext';
import Usps from './usps';
import AddToCartLink from '@/components/v2/product/AddToCartLink';
import PricingBoxHeader from './PricingBoxHeader';
import PricingBoxDelivery from './PricingBoxDelivery';
import PayLaterMessage from './PayLaterMessage';

export default function Product() {
  const {
    selectedOffer,
    selectedWarranty,
    isFetchingSku,
    selectedSkuDetails: { finalPrice },
  } = useProductPageContext();

  return (
    <div
      className={classNames('relative flex flex-col items-end', {
        'opacity-60': isFetchingSku,
      })}
    >
      <div className="mb-4 flex w-full flex-col px-5 lg:hidden">
        <PricingBoxDelivery align="center" className="text-[12px]" />
        <PayLaterMessage
          amount={finalPrice}
          className="mt-2 3xs:mt-4 xxs:mt-2"
        />
      </div>
      <div className="w-full border-[#ECF0F0] bg-white lg:rounded-md lg:border lg:shadow-[0_2px_12px_rgba(42,124,122,0.08)]">
        <div className="hidden px-5 py-4 lg:block">
          <PricingBoxHeader />
          <div className="mt-6 hidden gap-y-3 lg:grid lg:grid-cols-[minmax(0,1fr)_175px] lg:gap-x-3 xl:grid-cols-[minmax(0,1fr)_250px]">
            <Usps className="h-full bg-[linear-gradient(90deg,_#FFFFFF_0%,_#F8F8F8_100%)]" />
            <div className="flex h-full flex-col items-center justify-center gap-1.5">
              <AddToCartLink
                testingId="e2e-pdp-add-to-cart"
                className="w-full"
                fullHeight
                id="purchaseCont"
                offer={selectedOffer}
                selectedWarranty={selectedWarranty}
              />
            </div>
          </div>
          <PayLaterMessage amount={finalPrice} align="right" className="mt-3" />
        </div>
        <div className="px-5 lg:hidden">
          <Usps className="bg-white shadow-[2px_0_21px_0_rgba(9,_82,_58,_0.10)]" />
        </div>
      </div>
      <div className="hidden w-full justify-end px-5 lg:flex">
        <div className="w-full rounded-b border border-t-0 bg-[#F7F7F7] px-4 py-1.5 lg:min-w-[175px] xl:w-fit xl:min-w-[250px]">
          <PricingBoxDelivery align="center" />
        </div>
      </div>
    </div>
  );
}
